import React, { useState } from 'react';

import { Button } from '@mui/material';

import ConfirmationDialog from './ConfirmationDialog';

type Props = {
  buttonText: string;
  title: string;
  description: string;
  loading: boolean;
  confirmButtonLabel?: string;
  onSubmit: () => Promise<void>;
};

export default function DestructiveActionButton({
  buttonText,
  description,
  loading,
  title,
  onSubmit,
  confirmButtonLabel,
}: Props) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button type="button" onClick={() => setOpen(true)}>
        {buttonText}
      </Button>
      <ConfirmationDialog
        title={title}
        description={description}
        loading={loading}
        open={open}
        handleClose={handleClose}
        onSubmit={onSubmit}
        confirmButtonLabel={confirmButtonLabel}
      />
    </>
  );
}
